import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import * as i1 from '@angular/router';
import { get } from 'lodash-es';
class GdsRouteResolverService {
  constructor(router, appRegExs) {
    this.router = router;
    this.appRegExs = appRegExs;
    // When @upr-web-primer/layout-k2 header is replaced w/ GDS header these values will need to be adjusted
    this.fullHeaderHeight = 150;
    this.stickyHeaderHeight = 60;
    this.stickyOffset = 450; //based on @upr-web-primer/navigation
    this.siteNotificationSelector = '.notification-msg';
  }
  resolveRoute(route) {
    if (!route) {
      return;
    }
    const href = get(route, 'href');
    const anchor = get(route, 'anchor');
    let target = get(route, 'target');
    if (target) {
      if (!target.startsWith('_')) {
        target = '_' + target;
      }
    }
    // If routeLink href does not start with locale, it should not be considered a routeLink
    const isRouteLink = this.appRegExs.ROUTE_LINK_EXP?.exec(href);
    const currRoutePath = this.getRoutePath();
    const currRouteIndex = `/${href}`.indexOf(currRoutePath);
    if (target === '_routeLink' && !isRouteLink && (!currRoutePath || currRouteIndex === -1 || currRouteIndex > 1)) {
      target = '_top';
    }
    // Check for links on page
    if (href && this.isSamePageLink(href) || !href && anchor) {
      let hash = href ? href : anchor;
      hash = hash.replace('#', '');
      const currentWindowHash = window.location.hash.substring(1);
      hash === currentWindowHash ? this.scrollTo(hash, false) : window.location.hash = hash;
      return;
    }
    // Check for http or https
    // This link is already complete, do nothing
    if (this.appRegExs.FORMATTED_LINK_EXP.test(href)) {
      window.open(href, target);
      return;
    }
    // All other links are internal or relative links
    if (target === '_routeLink' && href) {
      this.getRoute(href, anchor);
      this.router.navigate([this.routePath], {
        queryParams: this.queryParams,
        fragment: this.hash,
        state: {
          redirect: this.router.url
        }
      });
      return;
    }
    if (href) {
      const basePath = this.getBasePath(href);
      const compiledUrl = anchor ? basePath + '#' + anchor : href;
      window.open(compiledUrl, target);
    }
  }
  getRoute(path, anchor) {
    this.resetRoutePath();
    if (!path) return;
    this.routePath = this.getBasePath(path);
    this.queryParams = this.getQueryParams(path);
    this.hash = !!anchor ? anchor : this.getHash(path);
  }
  resetRoutePath() {
    this.routePath = '';
    this.queryParams = null;
    this.hash = null;
  }
  getBasePath(path) {
    if (path.indexOf('?') > -1) {
      const routePathSplitted = path.split('?');
      return routePathSplitted[0];
    }
    if (path.indexOf('#') > -1) {
      const routePathSplitted = path.split('#');
      return routePathSplitted[0];
    }
    return path;
  }
  getQueryParams(path) {
    if (path.indexOf('?') > -1) {
      const routePathSplitted = path.split('?');
      const queryStringParams = routePathSplitted[1];
      const queryParams = JSON.parse('{"' + decodeURI(queryStringParams).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
      return queryParams;
    }
  }
  getHash(path) {
    if (path.indexOf('#') > -1) {
      const routeArray = path.split('#');
      return routeArray[1];
    }
  }
  isSamePageLink(href) {
    if (!href) {
      return false;
    }
    if (href.startsWith('#')) {
      return true;
    }
    return false;
  }
  getHashId(component) {
    return `hash-id-${get(component, 'Component.Title', '').replace(this.appRegExs.SPECIAL_CHARS_EXP, '')}-${get(component, 'ComponentTemplate.Title', '').replace(this.appRegExs.SPECIAL_CHARS_EXP, '')}`.toLowerCase().substring(0, 100);
  }
  scrollTo(hashId, timeout) {
    if (timeout) {
      setTimeout(() => {
        this.scrollToComponent(hashId);
      }, 1000);
      return;
    }
    this.scrollToComponent(hashId);
  }
  scrollToComponent(hashId) {
    const el = document.querySelector(`[data-hash-id='${hashId}']`);
    if (!el) return;
    const elTop = el.getBoundingClientRect().top;
    const docOffset = window.pageYOffset + elTop;
    const winYoffset = window.pageYOffset;
    let offset = winYoffset + elTop;
    if (docOffset >= this.stickyOffset) {
      offset = offset - this.stickyHeaderHeight;
    } else {
      offset = offset - this.fullHeaderHeight;
    }
    const siteNotification = document.querySelector(this.siteNotificationSelector);
    if (siteNotification) {
      offset = offset - siteNotification.clientHeight;
    }
    window.scrollTo({
      top: offset,
      behavior: 'smooth'
    });
  }
  getRoutePath() {
    const routeSegments = this.router.url.split('/');
    if (routeSegments.length > 1) {
      return '/' + routeSegments[1] + '/';
    }
    return '';
  }
  static {
    this.ɵfac = function GdsRouteResolverService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsRouteResolverService)(i0.ɵɵinject(i1.Router), i0.ɵɵinject('AppRegexs'));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsRouteResolverService,
      factory: GdsRouteResolverService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsRouteResolverService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.Router
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['AppRegexs']
    }]
  }], null);
})();
class GdsRouteResolverModule {
  static {
    this.ɵfac = function GdsRouteResolverModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsRouteResolverModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GdsRouteResolverModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [GdsRouteResolverService]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsRouteResolverModule, [{
    type: NgModule,
    args: [{
      providers: [GdsRouteResolverService]
    }]
  }], null, null);
})();

/*
 * Public API Surface of gds-route-resolver
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GdsRouteResolverModule, GdsRouteResolverService };
